import { NavLink, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import { FileText } from 'lucide-react'
import { NAVIGATION_COPY } from '@/locales/en'

type ResumeApplicationCardProps = {
    to: string
    activeOn?: string[]
    onClick?: () => void
    onHover?: () => void
    wrapperClassName?: string
    asListItem?: boolean
}

export const ResumeApplicationCard = ({
    to,
    activeOn,
    onClick,
    onHover,
    wrapperClassName,
    asListItem = false,
}: ResumeApplicationCardProps) => {
    const location = useLocation()
    const isActive = activeOn ? activeOn.some((route: string) => location.pathname === route) : location.pathname === to

    const card = (
        <NavLink
            to={to}
            onClick={onClick}
            onMouseEnter={onHover}
            className={() => {
                return clsx(
                    'flex space-x-3 items-center text-foreground border border-[#d5d8d3]',
                    'px-5 py-3 rounded-lg my-0.5',
                    {
                        'hover:bg-lime-50': !isActive,
                        'bg-secondary-light': isActive,
                    },
                )
            }}
        >
            <div className="flex-1 inline-flex flex-col justify-start items-start gap-6">
                <FileText className="w-6 h-6 relative overflow-hidden" />
                <div className="self-stretch flex flex-col justify-center items-start gap-6">
                    <div className="self-stretch flex flex-col justify-start items-start gap-2">
                        <div className="self-stretch justify-center text-base font-medium">
                            {NAVIGATION_COPY.resumeTitle}
                        </div>
                        <div className="self-stretch justify-start text-base font-normal">
                            {NAVIGATION_COPY.resumeDescription}
                        </div>
                    </div>
                </div>
            </div>
        </NavLink>
    )

    if (asListItem) {
        return <li className={clsx('mb-4', wrapperClassName)}>{card}</li>
    }

    return <div className={wrapperClassName}>{card}</div>
}
